<template>
    <c-dialog ref="dialog" :title="title" width="900" height="500px" button-name="转采购单" @resolve="resolve">
        <c-form ref="form" item-width="100%">
            <table class="detail-table">
                <thead>
                <tr>
                    <th style="width: 100px;">采购商家</th>
                    <th style="width: 200px;">采购商品</th>
                    <th style="width: 120px;">商品规格</th>
                    <th style="width: 80px;">下单数</th>
                    <th style="width: 80px;">转单数</th>
                    <th style="width: 80px;">操作</th>
                </tr>
                </thead>
                <tbody>
                <template v-for="(item, j) in productList">
                    <tr :key="j">
                        <td v-if="stationedCell(productList, j)" :rowspan="stationedCell(productList, j)">
                            <div class="position flex-column flex-center">
                                <p>{{item.stationed_company_name}}</p>
                            </div>
                        </td>
                        <td v-if="productCell(productList, j)" :rowspan="productCell(productList, j)">
                            <div class="position flex-column flex-center">
                                <c-image class="position-image" :src="item.product_img_url"></c-image>
                                <p>{{item.product_name}}</p>
                            </div>
                        </td>
                        <td>{{item.product_sku_spec}}</td>
                        <td>{{item.product_count}}</td>
                        <td>
                            <c-input v-model="item.purchase_product_count" type="number" decimal="0" :limit="[1,999]"></c-input>
                        </td>
                        <td>
                            <a v-if="productList.length > 1" class="remove" @click="deleteSKUOption(item, j)">删除</a>
                            <span v-else>--</span>
                        </td>
                    </tr>
                </template>
                </tbody>
            </table>
            <c-form-item type="region" label="收货地址"
                         province-name="delivery_province_id"
                         city-name="delivery_city_id"
                         county-name="delivery_county_id"
                         required>
            </c-form-item>
            <c-form-item type="input" label="收货地址" name="delivery_address" required word="此处收货地址使用【系统->基础数据->发货地址】功能中配置的默认地址数据"></c-form-item>
            <c-form-item type="input" label="收件人" name="delivery_name" required></c-form-item>
            <c-form-item type="input" label="联系电话" name="delivery_mobile" required></c-form-item>
            <c-form-item type="textarea" label="订单备注" name="order_remark"></c-form-item>
        </c-form>
    </c-dialog>
</template>

<script>
    export default {
        props: {
            multiple: Boolean
        },
        data() {
            return {
                title:'订单转采购单',
                serachParams: {},
                productList:[]
            }
        },
        computed: {
            //相同商家数据行合并
            stationedCell() {
                return (list, i) => {
                    if (i == 0 || list[i - 1].stationed_id != list[i].stationed_id) {
                        return list.filter(item => item.stationed_id == list[i].stationed_id).length;
                    }
                    return 0;
                }
            },
            //相同商品数据行合并
            productCell() {
                return (list, i) => {
                    if (i == 0 || list[i - 1].product_id != list[i].product_id) {
                        return list.filter(item => item.product_id == list[i].product_id).length;
                    }
                    return 0;
                }
            }
        },

        methods: {
            //查询默认收货地址
            loadDefaultAddress(){
                this.request({
                    url: '/delivery_address/get/default',
                    data: {},
                    success: data => {
                        if (data){
                            this.$refs.form.set(data);
                        }
                    }
                });
            },
            loadProductList() {
                this.request({
                    url: '/purchase/order/transferable/product/list',
                    data: this.serachParams,
                    success: data => {
                        this.productList = data.map(item => {
                            item.purchase_product_count = item.product_count;//默认转单数据
                            return item;
                        });;
                    }
                });
            },

            open(serachParams) {
                this.serachParams = serachParams||{};
                this.loadDefaultAddress();
                this.loadProductList();
                this.$refs.dialog.open();
                if (this.serachParams && this.serachParams.order_number){
                    this.title = '订单【'+this.serachParams.order_number+'】转采购单';
                }
            },

            //删除部分SKU
            deleteSKUOption(custom, index, position) {
                this.productList.splice(index, 1);
            },

            resolve(stop, next) {
                stop();
                //转单数据非空
                if (!this.productList && this.productList.length == 0){
                    this.$message({
                        icon: 'fail',  // 图标（success：成功，fail：失败）
                        text: '至少存在一条转单商品SKU数据'
                    });
                }
                for(let i = 0;i<this.productList.length;i++){
                    var obj = this.productList[i];
                    if(!obj.purchase_product_count || obj.purchase_product_count == ''){
                        //转单数量必须大于0
                        this.$message({
                            icon: 'fail',  // 图标（success：成功，fail：失败）
                            text: '请输入转单数量'
                        });
                        return;
                    }
                    if(parseInt(obj.purchase_product_count)<=0){
                        //转单数量必须大于0
                        this.$message({
                            icon: 'fail',  // 图标（success：成功，fail：失败）
                            text: '转单数量必须是正整数'
                        });
                        return;
                    }
                }
                var formData = this.$refs.form.serialize();
                if (!formData.delivery_county_id || formData.delivery_county_id==0
                    ||!formData.delivery_address || formData.delivery_address==''){
                    this.$message({
                        icon: 'fail',  // 图标（success：成功，fail：失败）
                        text: '请完善采购订单收货地址信息'
                    });
                    return;
                }
                if (!formData.delivery_name || formData.delivery_name==''
                    ||!formData.delivery_mobile || formData.delivery_mobile==''){
                    this.$message({
                        icon: 'fail',  // 图标（success：成功，fail：失败）
                        text: '请完善采购订单收货人相关信息'
                    });
                    return;
                }
                this.$confirm({
                    text: '是否确定已当前填写的数据进行转单，转单操作只能进行一次，转单生成的数据不允许修改，请谨慎操作',
                    buttonName: '确认转单',  // 确定按钮文字
                    resolve: () => {
                        this.request({
                            url: '/purchase/order/add',
                            data: {
                                order_number: this.serachParams.order_number,
                                receiving_name:formData.delivery_name,
                                receiving_phone:formData.delivery_mobile,
                                receiving_address_province_id:formData.delivery_province_id,
                                receiving_address_city_id:formData.delivery_city_id,
                                receiving_address_county_id:formData.delivery_county_id,
                                receiving_address:formData.delivery_address,
                                order_remark:formData.order_remark,
                                product_list: this.productList
                            },
                            loading: true,
                            success: () => {
                                this.$message({
                                    icon: 'success',  // 图标（success：成功，fail：失败）
                                    text: '转单成功'
                                });
                                this.$bus.$emit('order.update', {});
                                next();
                            }
                        });
                    }
                });
            }
        }
    }
</script>

<style lang="stylus" scoped>
.detail-table {
    width: 100%;

    thead {
        background: #F9F9F9;
    }
    tbody {
        background: #fff;
    }
    th, td {
        width: 100px;
        height: 40px;
        padding: 0 10px;
        line-height: 40px;
        border: 1px solid #ddd;
        color: #444;
        font-size: 12px;
        text-align: left;
    }

    th {
        b {
            margin-right: 5px;
            color: #f00;
        }

        a {
            margin-left: 5px;
        }
    }

    td {
        position: relative;

        .c-input {
            height: 30px;
            border-style:solid
        }
    }
    margin: -1px 0 12px;

    .position {
        padding-top: 10px;

        &-image {
            width: 60px;
            height: 60px;
        }

        p {
            line-height: 30px;
        }
    }

    .color {
        > div {
            border: 1px solid #eee;
            padding: 4px;
            margin-right: 6px;

            div {
                width: 20px;
                height: 20px;
            }
        }
    }

    .remove {
        font-size: 12px;
        color: #f00;
    }
}
</style>